import { Link as HygraphLink } from '@/lib/types';

import Link from '@/components/link';

import linkTransformer from '@/hygraph/transformers/link.transformer';

export default function LinkRenderer(props: unknown) {
  const linkProps = linkTransformer(props as HygraphLink);

  if (!linkProps) {
    return <></>;
  }

  return <Link {...linkProps} />;
}
